import React, {useEffect} from 'react';
import * as SentryReact from '@sentry/react';
import ENV from '../environment';
const SentryWrapper = () => {
  const dsnNumber = ENV.SENTRY_DSN;
  useEffect(() => {
    if (!ENV.DEBUG_ENABLED) {
      SentryReact.init({
        dsn: dsnNumber,
        tracesSampleRate: 0.5,
        autoSessionTracking: false,
        ignoreErrors: [
          /\d+ms timeout exceeded/,
          /Internal error opening backing store for indexedDB\.open/,
          /backing store for indexedDB/,
          /Network Error/,
          /NetworkError/,
          /EventSource error/,
          /Permissions check failed/,
          /not granted/,
          /Failed to start the audio device/,
          /Cannot request fullscreen in a hidden document/,
          /Database deleted by request of the user/,
          /Connection to Indexed Database server lost/,
          /Attempt to get a record from database without an in-progress transaction/,
          /TimeoutError: Transaction timed out/,
          /QuotaExceededError/,
          /AbortError.*IDBTransaction/,
          /A request was aborted/,
          /Request failed with status code 401/,
          /scrollToIndex out of range/,
          /Converting circular structure to JSON/,
        ],
        denyUrls: [
          /chrome-extension:\/\//,
          /extensions\//,
          /^chrome:\/\//,
          /^moz-extension:\/\//,
          // Third-party analytics scripts throw their own (non-actionable)
          // cross-origin / SecurityErrors — not our code.
          /clarity\.js/,
          /clarity\.ms/,
        ],
      });
    }

    return () => {
      SentryReact.close();
    };
  }, [dsnNumber]);

  return null;
};

export default SentryWrapper;
